"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NAVIGATION_SKELETON = exports.NAVIGATION = void 0;
const NAVIGATION = exports.NAVIGATION = 'navigation';
const NAVIGATION_SKELETON = exports.NAVIGATION_SKELETON = 'navigation-skeleton';
